import React, { useState, useMemo } from 'react';
import useLanguage from '../hooks/useLanguage';
import productsData from '../data/products.json';
import translationsData from '../data/translations.json';
import ProductGrid from '../components/products/ProductGrid';
import ProductFilter from '../components/products/ProductFilter';

/**
 * Products Page
 * Displays all products with category filtering
 */
const Products = () => {
  const { language } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Extract unique categories from products
  const categories = useMemo(() => {
    const uniqueCategories = new Set();
    productsData.products.forEach((product) => {
      uniqueCategories.add(JSON.stringify({
        value: product.category,
        label: product.category,
        labelEn: product.categoryEn,
      }));
    });
    return Array.from(uniqueCategories).map((cat) => JSON.parse(cat));
  }, []);

  // Filter products based on selected category
  const filteredProducts = useMemo(() => {
    if (selectedCategory === 'all') {
      return productsData.products;
    }
    return productsData.products.filter(
      (product) => product.category === selectedCategory
    );
  }, [selectedCategory]);

  const pageTitle = language === 'ko' ? translationsData.titles.products : translationsData.titles.productsEn;
  const pageDescription = language === 'ko'
    ? '첨단 레이다 센서 기술을 확인하세요'
    : 'Explore Our Advanced Radar Sensor Technology';

  return (
    <div className="min-h-screen bg-gray-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {pageTitle}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {pageDescription}
          </p>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-6"></div>
        </div>

        {/* Product Filter */}
        <ProductFilter
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={setSelectedCategory}
        />

        {/* Products Grid */}
        {filteredProducts.length > 0 ? (
          <ProductGrid products={filteredProducts} />
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">
              {language === 'ko' ? '해당 카테고리의 제품이 없습니다.' : 'No products found in this category.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
